import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Spinner,
} from '@chakra-ui/react';
import { IconArrowInbox } from 'central-icons/IconArrowInbox';

export type PdfPreviewModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  previewUrl?: string;
  downloadUrl?: string;
};

export const PdfPreviewModal = ({
  isOpen,
  onClose,
  title,
  previewUrl,
  downloadUrl,
}: PdfPreviewModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl">
      <ModalOverlay />
      <ModalContent height="90vh">
        <ModalHeader color="navyBlue.500" fontSize="md" py={3} pl={4}>
          {title}
        </ModalHeader>
        <ModalCloseButton />
        {downloadUrl && (
          <Button
            title="Download file"
            leftIcon={<IconArrowInbox size={16} />}
            as="a"
            href={downloadUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Download file"
            size="sm"
            variant="ghost"
            colorScheme="navyBlue"
            position="absolute"
            top={2}
            right={12}
          >
            Download
          </Button>
        )}
        <ModalBody p={0} overflow="hidden">
          {previewUrl ? (
            <object
              data={previewUrl}
              type="application/pdf"
              width="100%"
              height="100%"
            >
              <p>
                Your browser does not support PDFs.
                <a href={previewUrl}>Download the PDF</a> to view it.
              </p>
            </object>
          ) : (
            <Spinner />
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
